

/**
 * Insert element after another element in DOM
 * @param afterNode
 * @param newNode
 */
export function insertAfter(afterNode: HTMLElement | SVGElement, newNode: HTMLElement | SVGElement): void {
    if (afterNode.parentNode) {
        afterNode.parentNode.insertBefore(newNode, afterNode.nextSibling);
    }
}

/**
 * Get the topmost window we're allowed access to
 */
export function getTopSafeFrame(): Window {
    let w = (window as Window);

    // As long as a parent exists
    while (w.parent && w !== w.parent) {
        try {
            w.parent.location.href;
            if (!w.parent.document) {
                break;
            }
            w = w.parent;
        }
        catch (e) {
            break;
        }
    }
    return w;
}

/**
 * If we have access to top window, return it.
 */
export function accessTopWindow(): Window | undefined {
    let topWindow;

    // Check if top window is accessible
    try {
        // Break if access to document is forbidden (throws an error)
        const readyState = window.top?.document.readyState;
        topWindow = readyState ? window.top : undefined;
    // eslint-disable-next-line no-empty
    } catch (e) { }

    return topWindow;
}

export function isIframe(w: Window = window): boolean {
    try {
        return w.self !== window.top;
    } catch (e) {
        return true;
    }
}
